import React from 'react'
import styles from './WarningBadge.module.scss'

interface PropsType {
  label: string
  isOutOfStock?: boolean
}

const WarningBadge: React.FC<PropsType> = (props: PropsType) => {
  const { label, isOutOfStock = true } = props

  const classes = {
    STOCK: { container: styles.outOfStockContainer, span: styles.spanStock },
    INACTIVE: { container: styles.inactiveContainer, span: styles.spanInactive },
  }[isOutOfStock ? 'STOCK' : 'INACTIVE']

  return (
    <div className={classes.container}>
      <span className={classes.span}>
        {label}
      </span>
    </div>
  )
}
export default WarningBadge
